module.exports = __webpack_public_path__ + "static/media/07fa-prime.a025de2a.png";